import styled from 'styled-components';
import { H3, P1 } from '../../styles/FontStyles';

const PortfolioItemDisabledStyled = styled.div`
  position: absolute;
  left: 0;
  right: 0;
  top: 0;
  bottom: 0;
  background-color: ${({ theme }) => theme.colors.neutral0}cc;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  padding: 20px;
  border-radius: 24px;
  text-align: center;
`;

export const PortfolioItemDisabled = ({
  title,
  subtitle
}: {
  title: string;
  subtitle: any;
}) => {
  return (
    <PortfolioItemDisabledStyled>
      <H3>{title}</H3>
      <P1>{subtitle}</P1>
    </PortfolioItemDisabledStyled>
  );
};
